import React, { useState } from "react"

import {
  ColorPageContainer,
  ContentContainer,
} from "components/Containers"
import { Subheading } from "components/Parallax/Subheading"
import { Hero } from "components/Hero"
import { Timeline } from "components/Timeline"
import { useTimelineData } from "shared/Hooks/Timeline"
import { ScrollTopButton } from "components/ScrollTopButton"
import SEO from "components/seo"

const Biography = () => {
  const data = useTimelineData().biography
  const [id, setId] = useState(0)
  const handleTimelineClick = id => {
    setId(id)
  }
  return (
    <>
      <SEO title="Biografia Mistrza - Fundacja Beksiński" description="Linia czasu z życia i twórczości Zdzisława Beksińskiego. Zapoznaj się z biografią mistrza."/>
      <Hero
        bigTitle={data[id].title}
        outlineTitle={data[id].heading}
        timeline
        imagesHook={data[id].heroPhotos}
      >
        <Timeline onClick={handleTimelineClick} />
      </Hero>
      <ColorPageContainer pageColor="#ffa290">
        <Subheading color="#fff">{data[id].subheading}</Subheading>
        <ContentContainer>{data[id].content}</ContentContainer>
        <ScrollTopButton />
      </ColorPageContainer>
    </>
  )
}

export default Biography
